import React from 'react';
import {observer} from 'mobx-react';
import {observable} from 'mobx';
import {Modal, ModalButtons} from 'shared/components/modals';
import {ObjectSelect2, CheckboxWithLabel, UploadFiles} from 'shared/components';
import {FormLayout} from 'shared/components/forms';

const UploadDocumentModal = observer(({uiState, onSave}) => {
  const {uploadModalOpen, uploadModalFiles, foldersInModalDropdown, uploadModalFolder, uploadModalShareWithEmployee, isUploading} = uiState;

  return (
    <Modal
      isOpen={uploadModalOpen}
      onHide={() => uiState.closeUploadModal()}
      size='sm'
      title='employees.profile.documents.Upload File(s)'
    >
      <FormLayout>
        <ObjectSelect2
          label='employees.profile.documents.Folder'
          items={foldersInModalDropdown}
          value={uploadModalFolder}
          onChange={value => uiState.uploadModalFolder = value}
          allowClear
        />
        {uiState.canShareWithEmployee &&
          <CheckboxWithLabel
            className='mt2'
            label='employees.profile.documents.Share with employee'
            checked={uploadModalShareWithEmployee}
            onChange={e => uiState.uploadModalShareWithEmployee = e.checked}
          />
        }
        <UploadFiles
          defaultFiles={observable([])}
          onChange={files => uiState.uploadModalFiles = files}
        />
        <ModalButtons
          saveEnabled={uploadModalFiles.length > 0 && !isUploading}
          onSave={onSave}
          onCancel={() => uiState.closeUploadModal()}
        />
      </FormLayout>
    </Modal>
  );
});

export default UploadDocumentModal;
